import React, {useState} from 'react'
import axios from 'axios'
import {format} from 'date-fns'
import styles from './DownloadFile.module.css'

// Add prop validation
import PropTypes from 'prop-types'

DownloadFile.propTypes = {
    file_url: PropTypes.string.isRequired,
    file_name: PropTypes.string.isRequired,
    uploaded_at: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
}

const getFileExtension = (fileType) => {
    switch (fileType) {
    // Documents
    case 'application/pdf': return '.pdf';
    case 'application/msword': return '.doc';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return '.docx';
    case 'application/vnd.ms-excel': return '.xls';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return '.xlsx';
    case 'application/vnd.ms-powerpoint': return '.ppt';
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': return '.pptx';
    case 'text/plain': return '.txt';
    case 'text/csv': return '.csv';
    case 'application/rtf': return '.rtf';
    case 'application/vnd.oasis.opendocument.text': return '.odt';
    case 'application/vnd.oasis.opendocument.spreadsheet': return '.ods';
    case 'application/vnd.oasis.opendocument.presentation': return '.odp';

    // Images
    case 'image/jpeg':
    case 'image/jpg': return '.jpg';
    case 'image/png': return '.png';
    case 'image/gif': return '.gif';
    case 'image/bmp': return '.bmp';
    case 'image/tiff': return '.tiff';
    case 'image/webp': return '.webp';
    case 'image/svg+xml': return '.svg';
    case 'image/x-icon': return '.ico';
    case 'image/avif': return '.avif';
  }
}

function DownloadFile({file_url, file_name, uploaded_at, token}) {
    const [downloading, setDownloading] = useState(false)

    const handleFileClicked = async (file_url) => {
      // Check if file_url contains a 'https://' prefix, if it does not, replace 'http://' with 'https://'
      if (!file_url.startsWith('https://')) {
        file_url = file_url.replace('http://', 'https://');
      }
        try {
            setDownloading(true)
          const response = await axios.get(file_url, {
            headers: {
              'Authorization': `Bearer ${token}`
            },
            responseType: 'blob' // Important: This tells Axios to expect a binary response
          });

          setDownloading(false)
          
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const url = window.URL.createObjectURL(blob);
    
          const link = document.createElement('a');
          link.href = url;
    
          window.open(link, "_blank")
          link.remove();
          window.URL.revokeObjectURL(url);
    
        } catch(err){
          console.error('Error while opening file: ', err)
          setDownloading(false)
        }
      }

  return (
    <div className={styles.tradeFile} onClick={() => handleFileClicked(file_url)}>
        <div className='d-flex justify-content-between align-items-center gap-2'>
            <div>{file_name}</div>
            {downloading && <div className="spinner-border spinner-border-sm" role="status" />}
        </div>
        <div className="fs-6">{uploaded_at}</div>
    </div>
  )
}

export default DownloadFile